type IModelCategory = {
    name: string;
    models: number[]
}

export const ModelCategories: IModelCategory[] = [
    {
        name: "Прямі",
        models: [ 501, 505, 514 ]
    },
    {
        name: "Завужені",
        models: [ 502, 511, 512 ]
    }
];